<template lang="pug">
  v-container.pb-16
    account-settings
    v-btn.mb-6.mt-2.button-md(color="danger500" depressed dark block @click="handleLogout") Logout
</template>

<script>

import AccountSettings from "@/components/marketing/merchantapp/settings/AccountSettings.vue";

export default {
  components: {AccountSettings},
  methods: {
    handleLogout() {
      this.$router.push('/signout/merchant-app')
    }
  },
}
</script>

<style scoped>

</style>